<template>
  <div :class="{'breadcrumb-gi': isGioielleriaItalianaB2B, 'breadcrumb-ama': isAma, ['breadcrumb-plugin breadcrumb-plugin-' + theme]: !isAma && !isGioielleriaItalianaB2B}">
    <div class="breadcrumb-row" v-if="buildYourJewelMode">
      <span class="path" :class="{ 'border-top-gold': isGioielleriaItalianaB2B && (productType == 'JEWELLERY' || productType == 'GOLDSMITH')}">
        <span class="cursor-pointer" @click="goToHome()" v-if="showHomeLink">Home</span>
      </span>
    </div>
    <div class="breadcrumb-row">
      <div class="go-to-btn" v-if="productType && productType == 'GOLDSMITH'">
        <span class="cursor-pointer" @click="navigateTo({ productType: 'JEWELLERY' })">{{
          $t("goToGio")
        }}</span>
      </div>
    </div>
    <!-- <div class="breadcrumb-row">
      <div class="go-to-btn" v-if="productType == 'JEWELLERY' && isGioielleriaItalianaB2B">
        <span class="cursor-pointer" @click="navigateTo({ productType: 'GOLDSMITH' })">{{
          $t("goToOr")
        }}</span>
      </div>
    </div> -->
    <div class="breadcrumb-row" v-if="!buildYourJewelMode">
      <span class="path" :class="{ 'border-top-gold': isGioielleriaItalianaB2B && (productType == 'JEWELLERY' || productType == 'GOLDSMITH')}">
        <span class="cursor-pointer" @click="goToHome()" v-if="showHomeLink">Home</span>
        <span class="cursor-pointer" v-if="showProductType"
          @click="navigateTo({ productType: productType })">
          <font-awesome-icon class="angle-right" :icon="['fas', 'angle-right']" v-if="showHomeLink"/>
          {{
            $t(productType.toLowerCase())
          }}
        </span>
        <span v-if="showCategoryName">
          <font-awesome-icon class="angle-right" :icon="['fas', 'angle-right']" />
          <span class="cursor-pointer" v-if="currentCategoryDetail && currentCategoryDetail.name"
            @click="navigateTo({ productType: productType, typeId: currentCategoryDetail.id })">
            {{
              currentCategoryDetail.name
            }}
          </span>
          <span class="cursor-pointer" v-else-if="currentProductCategoryDetail && currentProductCategoryDetail.name"
            @click="navigateTo({ productType: productType, typeId: currentProductCategoryDetail.id })">
            {{
              currentProductCategoryDetail.name
            }}
          </span>
          <span v-else-if="currentCategory">
            {{
              currentCategory.name ? currentCategory.name : $t("allCategories")
            }}
          </span>
        </span>
        <span v-if="searchJewel.text">
          <font-awesome-icon class="angle-right" :icon="['fas', 'angle-right']" />
          "{{ searchJewel.text }}"
        </span>
        <span v-if="currentJewelSelection && currentJewelSelection.name">
          <font-awesome-icon class="angle-right" :icon="['fas', 'angle-right']" />
          {{ currentJewelSelection.name }}
        </span>
        <span v-if="currentProductSelection && currentProductSelection.name">
          <font-awesome-icon class="angle-right" :icon="['fas', 'angle-right']" />
          {{ currentProductSelection.name }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Vue from "vue";

export default {
  name: "Breadcrumb",
  computed: {
    showHomeLink() {
      return !this.isAma;
    },
    showCategoryName() {
      return this.productType && this.productType != 'KIT' && this.productType != 'STONES'
    },
    showProductType() {
      return this.productType && this.productType != 'BLISTER' &&(!this.isAccessoryCategory || this.productType == 'KIT')
    },
    isAccessoryCategory: function () {
      return Vue.isAccessory(this.productType);
    },
    productType: function () {
      return this.currentCategory?.productType || this.currentJewelSelection?.productType;
    },
    ...mapState({
      isGioielleriaItalianaB2B: (state) => state.config.isGioielleriaItalianaB2B,
      theme: (state) => state.config.theme,
      currentCategory: (state) => state.list.currentCategory,
      searchJewel: (state) => state.list.searchJewel,
      currentJewelSelection: (state) => state.detail.currentJewelSelection,
      currentCategoryDetail: (state) => state.detail.currentCategory,
      currentProductSelection: (state) => state.productDetail.currentJewelSelection,
      currentProductCategoryDetail: (state) => state.productDetail.currentCategory,
      isAma: (state) => state.config.isAma,
      buildYourJewelMode: (state) => state.buildYourJewel.buildYourJewelMode,
    })
  },
  methods: {
    ...mapMutations("list", [
      "setJewelsList",
      "resetJewelSearch"
    ]),
    navigateTo: function (search) {
      if (
        this.$route.name != "list.sublist"
      ) {
        this.$router.push({
          name: "list.sublist",
          params: {
            productType: search.productType,
            typeId: search.typeId || null,
          },
        });
      }
      this.$emit("navigateTo", search);
    },
    goToHome: function () {
      this.setJewelsList();
      this.$router.push({ name: "list" });
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/_variables.scss";

.breadcrumb-gi {
  background: linear-gradient(0deg, #44607E 0%, #254669 47%, #00274F 100%);
  text-align: left;
  color: #fff;
  text-transform: uppercase;
  font-family: var(--secondary-font-family);
  font-size: 20px;
  padding-bottom: 10px;
}

.breadcrumb-ama {
  background: var(--ama-gray);
  text-align: left;
  //color: var(--ama-white);
  text-transform: uppercase;
  font-family: var(--secondary-font-family);
  font-size: 18px;
  border-bottom: 1px solid var(--ama-gray);

  .path {
    width: 100%;
  }
}

.breadcrumb-plugin {
  background: var(--primary-color-1);
  text-align: left;
  color: var(--secondary-color-1);
  text-transform: uppercase;
  font-family: var(--secondary-font-family);
  font-size: 20px;
  padding-bottom: 10px;
}

.breadcrumb-plugin-2 {
  background: var(--secondary-color-1);
  color: var(--primary-color-1);
}

.path {
  padding: 10px 0px;
  display: inline-block;
}

.border-top-gold {
  border-top: 1px solid var(--secondary-color-1);
}

.breadcrumb-row {
  padding-right: 3rem !important;
  padding-left: 3rem !important;

  div {
    padding: 10px 0px;
  }
}

.angle-right {
  margin: 0px 10px;
}

@media only screen and (max-width: 768px) {
  .breadcrumb-gi {
    font-size: 15px;
  }

  .angle-right {
    margin: 0px 5px;
  }

}
</style>
